import {
	EnhancedCheckboxRHF,
	EnhancedDropDownRHFWithLabel,
	ITest,
	LabelPosition,
	RHookFormMaskedTextField,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useState } from "react";

interface ITrustBankSetupFieldsPanel extends ITest {


}
export const TrustBankSetupFieldsPanel: FC<
	ITrustBankSetupFieldsPanel
> = ({ }) => {
	
	return (
		<>
			<EnhancedDropDownRHFWithLabel
				label="Bank"
				selectName="bank"
				items={[
					{ label: "Canadian Imperial Bank of Commerce (326)", value: 100 },
					{ label: "DC Royal Bank of Canada (003)", value: 200 },
				]}
				selectedItem={100}
				testId="bank"
				labelPosition={LabelPosition.Top}
			// onSelectionChangeHandler={}
			// required
			/>
			<EnhancedDropDownRHFWithLabel
				label="Transaction Method"
				selectName="transactionMethod"
				items={[
					{ label: "FTP", value: 200 },
					{ label: "EDI", value: 100 },
				]}
				selectedItem={200}
				testId="bank"
				labelPosition={LabelPosition.Top}
			// onSelectionChangeHandler={}
			// required
			/>
			<RHookFormTextFieldWithLabel
				id="trustBankName"
				testId={`trust-bank-name`}
				label="Trust Bank Name"
				labelPosition={LabelPosition.Top}

			/>
			<RHookFormTextFieldWithLabel
				id="debitTransactionCode"
				testId="debit-transaction-code"
				label="Debit Transaction Code"
				labelPosition={LabelPosition.Top}

			/>
			<RHookFormTextFieldWithLabel
				id="debitClientId"
				testId="debit-client-id"
				label="Debit Client Id"
				labelPosition={LabelPosition.Top}

			/>
			<RHookFormTextFieldWithLabel
				id="creditTransactionCode"
				label="Credit Transaction Code"
				testId={`credit-transaction-code`}
				labelPosition={LabelPosition.Top}

			/>
			<RHookFormTextFieldWithLabel
				id="creditClientId"
				label="Credit Client Id"
				testId={`creditClientId`}
				labelPosition={LabelPosition.Top}

			/>

			{/* <RHookFormMaskedTextFieldWithLabel
				id="debitTransactionCode"
				testId="debit-transaction-code"
				inputMaskPattern="00000"
				// placeholder="5 Digits"
				placeholder="3062"
				label="Debit Transaction Code"
			/> */}
			{/* <RHookFormMaskedTextFieldWithLabel
				id="debitClientId"
				testId="debit-client-id"
				inputMaskPattern={"003"}
				placeholder={"003"}
				label="Debit Client Id"
				labelPosition={LabelPosition.Top}
			/> */}
			{/* <RHookFormMaskedTextFieldWithLabel
				id="creditTransactionCode"
				testId={`credit-transaction-code`}
				label="Credit Transaction Code"
				placeholder={"555"}
				inputMaskPattern={"555"}
				labelPosition={LabelPosition.Top}

			/> */}
			{/* <RHookFormNumberFieldWithLabel
				label="Credit Client Id"
				id="creditClientId"
				testId={`creditClientId`}
				labelPosition={LabelPosition.Top}
				placeholder="6666"
			/> */}
			<EnhancedCheckboxRHF
				name="defaultTrustBank"
				testId="Default-Accountant"
				checkboxLabel="Default Trust Bank"
				checked={false}
			// labelPosition={LabelPosition.Left}
			/>
		</>
	);
};
